export const termsContent = [
  {
    title: "Acceptance",
    content: `It is important that you ("Client") read all the following terms and conditions carefully. This Terms of Use Agreement ("Agreement") is a legal agreement between you and Nobel AI Legal Inc. ("Nobel AI Legal", "Us", "Our" or "We"), which is the owner and operator of the Nobel AI Legal portal website ("Portal"). It states the terms and conditions under which you may access and use the Portal and all written and other materials displayed or made available through the Portal, including articles, text, photographs, images, and other content ("Content").

By accessing and using the Portal, you are indicating your acceptance to be bound by the terms and conditions of the Agreement. These terms apply in addition to, and do not replace, the General Terms and Conditions of the Nobel AI Legal website, which can be found at https://www.examplelegalportal.com/terms. Where these terms conflict with the General Terms and Conditions, these terms shall govern Portal use.

If you do not accept these terms, you must not access or use the Portal. Nobel AI Legal may revise this Agreement at any time without notice. Please check the Portal Terms of Use frequently for updates.`,
  },
  {
    title: "Portal Description",
    content: `Nobel AI Legal manages an internet-based Portal designed to give clients the opportunity to:
- Create a personal health record containing information such as health history, medications, and allergies
- Gain greater access to personal health information
- Interact and share information with authorized users like healthcare providers
- Seek general information pertinent to medical conditions`,
  },
  {
    title: "Registering for the Portal Account",
    content: `When you enroll in Nobel AI Legal's services, you'll create a personal Portal account ("Account") containing your health information. Your Account will be password protected and consists of:
- A username ("User Name")
- A password ("Password")

You agree to:
1. Provide true, accurate, current and complete information
2. Maintain and promptly update your information
3. Keep your Password confidential
4. Notify Nobel AI Legal immediately of any unauthorized use

Nobel AI Legal may suspend or terminate your Account if we suspect your information is untrue or incomplete.`,
  },
  {
    title: "Portal Provided Only as a Convenience",
    content: `The Portal is provided as a convenience to clients. Key points:
- Participation is voluntary
- You may discontinue participation at any time
- Nobel AI Legal may modify or terminate the Portal without notice
- The Portal and Content are provided "AS IS" without warranties
- Nobel AI Legal cannot guarantee Portal security
- Information transmission over the internet may not be secure`,
  },
  {
    title: "Portal Content is Not Medical Advice",
    content: `Important limitations:
- Always seek advice from a qualified healthcare provider
- Never disregard professional medical advice because of Portal content
- Information on the Portal is not exhaustive
- Tools and calculators are for general informational purposes only
- Do not use Portal content for self-treatment`,
  },
  {
    title: "Limitations as Communications Tool",
    content: `Critical restrictions:
- Do not use the Portal for medical emergencies (call 911)
- The Portal does not create physician-patient relationships
- Emergency communications should use proper channels`,
  },
  {
    title: "Third-Party Links",
    content: `The Portal may contain third-party content and links. Important notes:
- Nobel AI Legal does not endorse third-party content
- We are not responsible for third-party providers
- Links to the Portal require Nobel AI Legal's consent`,
  },
  {
    title: "Closing of Accounts",
    content: `Account termination details:
- You can close your Account at any time
- Nobel AI Legal may close Accounts for any reason
- Upon closure, you'll have 30 days to download your information
- After 30 days, information will be securely destroyed
- Special procedures apply for accounts of deceased persons`,
  },
  {
    title: "Electronic Communication",
    content: `Electronic communications policy:
- We consider electronic communications from you as authorized
- Copies of electronic communications are admissible as evidence
- You waive any right to object to their introduction as evidence`,
  },
  {
    title: "Privacy of Information",
    content: `Privacy provisions:
- By accepting this Agreement, you consent to Nobel AI Legal's collection and use of your information
- Your information will be password protected
- You can permanently remove your information at any time
- De-identified information may be retained and used by Nobel AI Legal`,
  },
  {
    title: "Sharing Function",
    content: `If you use the sharing function:
- You consent to disclosing information to authorized users
- You're responsible for verifying recipient identities
- Nobel AI Legal isn't liable for unauthorized disclosure
- If you're a recipient, you must maintain confidentiality`,
  },
  {
    title: "Fees and Refund Policy",
    content: `Payment terms:
- All fees are in Canadian dollars
- Payments are generally final
- Limited refunds may be available in specific circumstances:
  * If required documents aren't accepted
  * If record requests aren't completed through no fault of yours`,
  },
  {
    title: "Limitation of Liability",
    content: `Nobel AI Legal's liability is limited:
- We're not liable for any damages from your Portal use
- This includes direct, indirect, incidental or consequential damages
- Applies regardless of the cause (contract, tort, etc.)
- Applies even if we knew of potential damages`,
  },
  {
    title: "Indemnity",
    content: `You agree to indemnify Nobel AI Legal against:
- Any claims resulting from your breach of this Agreement
- Any claims related to your Portal access or use
- Including legal fees and disbursements`,
  },
  {
    title: "Copyright and License",
    content: `Intellectual property terms:
- Content is protected by copyright
- You're granted a limited, non-transferable license
- You may download single copies for personal use
- You may not repost items online outside the Portal`,
  },
  {
    title: "General Legal Terms",
    content: `Additional provisions:
- The Portal is operated from Ontario, Canada
- Ontario law governs this Agreement
- Any disputes fall under Ontario court jurisdiction
- Waiver of one breach doesn't waive others
- Invalid provisions don't affect the rest of the Agreement`,
  },
  {
    title: "Contact Information",
    content: `For questions about these terms:
Nobel AI Legal Inc.
123 Example Street, Suite 100
Toronto, ON M5V 1A1
Email: info@examplelegalportal.com
Phone: 1-800-555-1234
Fax: 1-800-555-5678`,
  },
];
